module.exports = __webpack_public_path__ + "static/media/map-marker-minus.ce180ea5.svg";